import clsx from 'clsx';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import InternalCommentEditCategoryForm from './editCategoryForm';

import { useAppSelector } from '../../../../../../../hooks/global/typedReduxHooks';
import InternalCommentObject from '../../../../../../../interfaces/InternalCommentsObject';

import { Button } from '~/components/ui/button';

interface NoteCategoryProps {
  internalComment: InternalCommentObject;
}

function NoteCategory({ internalComment }: NoteCategoryProps) {
  const intl = useIntl();
  const [editMode, setEditMode] = useState(false);
  const investigatorNoteCategories = useAppSelector(
    (state) => state.reports.investigatorNoteCategories,
  );

  const assignedCategory = investigatorNoteCategories.find(
    (category) => category.id === internalComment.category?.id,
  );

  return (
    <div>
      {editMode ? (
        <InternalCommentEditCategoryForm
          internalComment={internalComment}
          selectedCategory={assignedCategory ?? null}
          onComplete={() => {
            setEditMode(false);
          }}
        />
      ) : (
        <Button
          variant='soft'
          size='sm'
          className={clsx(
            'flex h-7 rounded-md text-sm leading-3 font-normal py-1 px-3 items-center gap-2',
            {
              'bg-transparent text-gray-300 hover:bg-gray-100':
                !assignedCategory,
              'bg-teal-100 text-teal-500 hover:bg-teal-50': assignedCategory,
            },
          )}
          onClick={() => {
            setEditMode(true);
          }}
        >
          {assignedCategory?.name ??
            intl.formatMessage({ defaultMessage: 'Select category' })}
        </Button>
      )}
    </div>
  );
}

export default NoteCategory;
